import script from "./reportProfit.vue?vue&type=script&setup=true&lang=js"
export * from "./reportProfit.vue?vue&type=script&setup=true&lang=js"

import "./reportProfit.vue?vue&type=style&index=0&id=01c5aed8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01c5aed8"]])

export default __exports__